import Cookies from 'js-cookie';

// Move banners from end of body into header placeholder
const bannersContainer = document.getElementById('header-banners');
const bannerPlaceholder = document.getElementById('banner-placeholder');
if (bannersContainer && bannerPlaceholder) {
    bannerPlaceholder.appendChild(bannersContainer);
}

const banners = document.querySelectorAll('.banners .banner');
let hasVisibleBanner = false;
for (let banner of banners) {
    let now = new Date();
    if ((new Date(banner.dataset.from)) <= now && (new Date(banner.dataset.till)) >= now && (getCookie(`banner-${banner.dataset.bannerId}`) === null || banner.dataset.forceShow === '1')) {
        banner.classList.remove('d-none');
        hasVisibleBanner = true;
        window.dispatchEvent(new Event('headerBarMove'));
    }
}

// If no banner is visible, collapse the placeholder entirely
if (bannerPlaceholder && !hasVisibleBanner) {
    bannerPlaceholder.style.display = 'none';
}

// Recalculate header offset after banners are resolved
if (bannerPlaceholder) {
    document.dispatchEvent(new Event('resize'));
}

const bannersIcons = document.querySelectorAll('.banner.dismissable');
for (let banner of bannersIcons) {
    const button = banner.getElementsByClassName('dismissable-icon');

    if (button.length === 0) {
        continue;
    }

    button[0].addEventListener('click', function (e) {
        e.preventDefault();
        let days = banner.dataset.showAgainAfter;
        Cookies.set(`banner-${banner.dataset.bannerId}`, 'show-again-after', {expires: parseInt(days) === 0 ? 365 : parseInt(days)});
        banner.classList.add('d-none');

        // If no visible banners remain, collapse the placeholder
        if (bannerPlaceholder && !document.querySelector('.banners .banner:not(.d-none)')) {
            bannerPlaceholder.style.display = 'none';
        }

        document.dispatchEvent(new Event('headerBarClose'));
        window.dispatchEvent(new Event('resize'));
    }, false);
}

function getCookie(name) {
    const cookies = document.cookie.split(';');
    for (let cookie of cookies) {
        cookie = cookie.trim();
        let cookieName = name + '=';
        if (cookie.indexOf(cookieName) === 0) {
            return cookie.substring(cookieName.length, cookie.length);
        }
    }
    return null;
}
